import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertOctagon, FiHome, FiHelpCircle, FiArrowRight } from 'react-icons/fi';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-container">
        {/* Illustration */}
        <div className="not-found-illustration">
          <FiAlertOctagon size={120} />
        </div>

        {/* Content */}
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-heading">Page Not Found</h2>
          <p className="not-found-description">
            The page you are looking for doesn't exist or has been moved. 
            Let's get you back on track.
          </p>
        </div>

        {/* Navigation Links */}
        <div className="not-found-actions">
          <Link to="/dashboard" className="action-link primary">
            <FiHome className="me-2" />
            Go to Dashboard
            <FiArrowRight className="ms-2" />
          </Link>
          <Link to="/help" className="action-link secondary">
            <FiHelpCircle className="me-2" />
            Help & Support
            <FiArrowRight className="ms-2" />
          </Link>
        </div>

        {/* Quick Links */}
        <div className="quick-links">
          <p className="quick-links-title">Quick Navigation</p>
          <div className="quick-links-grid">
            <Link to="/dashboard" className="quick-link-item">
              Dashboard
            </Link>
            <Link to="/projects" className="quick-link-item">
              Projects
            </Link>
            <Link to="/help" className="quick-link-item">
              Help
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
